<template>
  <div
    class="flex items-center justify-center py-4 w-full"
  >
    <Spinner :size="12" />
  </div>
</template>

<script setup lang="ts">
import Spinner from '@/components/Spinner.vue'
</script>